var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaderboardBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 580,
    viewBox: "0 0 411 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5185_42069)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M546 306.916C546 543.248 397.135 632 213.5 632C29.8653 632 -119 543.248 -119 306.916C-119 70.5846 29.8653 -121 213.5 -121C397.135 -121 546 70.5846 546 306.916Z",
    fill: "#206CC6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5185_42069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -71,
    y: -58,
    width: 498,
    height: 471
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M426.974 209.661C426.974 357.486 315.498 413 177.987 413C40.4752 413 -71 357.486 -71 209.661C-71 61.8358 40.4752 -58 177.987 -58C315.498 -58 426.974 61.8358 426.974 209.661Z",
    fill: "#805AC6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5185_42069)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M297.293 31.2203L311.967 76.3823H359.453L321.036 104.294L335.71 149.456L297.293 121.544L258.876 149.456L273.55 104.294L235.133 76.3823H282.619L297.293 31.2203Z",
    fill: "white",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M20.2952 233.522L42.6556 302.34H115.015L56.4751 344.872L78.8354 413.691L20.2952 371.159L-38.2452 413.691L-15.8847 344.872L-74.425 302.34H-2.06525L20.2952 233.522Z",
    fill: "white",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M391.7 174.388L412.896 239.622L481.487 239.622L425.996 279.938L447.192 345.172L391.7 304.856L336.209 345.172L357.405 279.938L301.914 239.622L370.505 239.622L391.7 174.388Z",
    fill: "white",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M39.4879 -65.2621L63.8281 9.64942H142.595L78.8712 55.9473L103.211 130.859L39.4879 84.561L-24.2357 130.859L0.104553 55.9473L-63.619 9.64942H15.1477L39.4879 -65.2621Z",
    fill: "white",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M204.96 327.93L213.346 353.736H240.48L218.528 369.686L226.913 395.493L204.96 379.543L183.008 395.493L191.393 369.686L169.44 353.736H196.575L204.96 327.93Z",
    fill: "white",
    fillOpacity: 0.77
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5185_42069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 411,
    height: 580,
    fill: "white",
    transform: "matrix(-1 0 0 1 411 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardBg);
export default __webpack_public_path__ + "static/media/leaderboard_bg.71cf236ce32149b31d155889d3fb4778.svg";
export { ForwardRef as ReactComponent };